import React from "react";
import style from "./Style.module.css";
import logo from "../../asset/reverse_facebook.svg";

class FacebookLogin extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <div
        onClick={() => {
          this.props.loginFacebook();
        }}
        className={style.facebookButton}
      >
        <img alt="" src={logo} className={style.fLogo} />
        <div className={style.text}>Sign in with Facebook</div>
      </div>
    );
  }
}

export default FacebookLogin;
